import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { UpdateService } from 'src/app/services/update.service';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.page.html',
  styleUrls: ['./reviews.page.scss'],
})
export class ReviewsPage implements OnInit {
  public pageId = null;
  public reviews: any = [];
  public company: any = {};

  constructor(
    private actRoute: ActivatedRoute, 
    public settings: SettingsService,
    private update: UpdateService,    
  ) { 
    this.settings.log(1,'ReviewPage constructor start');
    this.pageId = this.actRoute.snapshot.params['id'];
  }

  ngOnInit() {
  }
  
  ionViewWillEnter() {
    let t = this;
    let s = this.settings;    
    this.settings.log(1,'ionViewWillEnter ReviewsPage');
    this.update.pageIsReady('ReviewsPage',this.pageId).then((result) => {
      // track page views
      t.settings.trackPageView('Reviews');
      this.reviews = result.reviews;
      this.company = result.company;

    }).catch((error)=>{
      this.settings.log(1,"ReviewsPage pageIsReady error " + error.message);
    }); 
	    
  }

}
